import { render, staticRenderFns } from "./photo-tab-table.vue?vue&type=template&id=91185e76&"
import script from "./photo-tab-table.vue?vue&type=script&lang=js&"
export * from "./photo-tab-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports